import React, { useState } from 'react';
import './CVPage.scss';
import Navbar from "../../../components/Navbar/Navbar";
import Footer from '../../../components/Footer/Footer';

import steel_counting from './steel_counting.jpg';
import vehicle_tracking from './vehicle_tracking.mp4';

const cases = [
    {
        id: 1,
        title: 'Vehicle Tracking and Counting',
        info: 'Real-time Traffic Analysis System',
        details: [
            { type: 'title', text: 'Introduction' },
            { type: 'text', text: 'A real-time vehicle tracking and counting system combining YOLO with tracking algorithms for more stable detection. The demo video is compressed for web viewing, hence the lower resolution.' },
            { type: 'title', text: 'Demo' },
            { type: 'video', src: vehicle_tracking }
        ],
    },
    {
        id: 2,
        title: 'Steel Bar Counting',
        info: 'Automated Counting System for Construction Materials',
        details: [
            { type: 'title', text: 'Introduction' },
            { type: 'text', text: 'An automated system for counting steel bars using computer vision. The system provides accurate counting results even in complex scenarios with overlapping bars.' },
            { type:'image', src: steel_counting}
        ],
    }
];

const CVPage = () => {
    const [activeModal, setActiveModal] = useState(null);

    const openModal = (id) => {
        setActiveModal(id);
    };

    const closeModal = (e) => {
        if (e.target.className === 'case-modal') {
            setActiveModal(null);
        }
    };

    return (
        <div className="rl-page">
            <Navbar />
            <section className="slide-card-header">
                <div className='wrapper'>
                    <div className="outer-frame"></div>
                    <div className="inner-container">
                        <h1>Computer Vision</h1>
                    </div>
                </div>
            </section>

            <section className="rl-content">
                <div className="cases-grid">
                {cases.map((caseItem, index) => (
                        <div 
                            key={caseItem.id} 
                            className="case-card"
                            onClick={() => openModal(caseItem.id)}
                        >
                            <div className="case-header">
                                <div className="case-number">{index + 1}</div>
                                <h3>{caseItem.title}</h3>
                                <div className="case-info">{caseItem.info}</div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Modal */}
                <div 
                    className={`case-modal ${activeModal ? 'active' : ''}`} 
                    onClick={closeModal}
                >
                    {activeModal && (
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3>{cases.find(c => c.id === activeModal)?.title}</h3>
                                <div className="close-button" onClick={() => setActiveModal(null)}></div>
                            </div>
                            <div className="modal-body">
                                <div className="modal-details">
                                    {cases.find(c => c.id === activeModal)?.details.map((detail, index) => {
                                        if (detail.type === 'image') {
                                            return (
                                                <div key={index} className="image-container">
                                                    <img src={detail.src} alt={`Case detail ${index + 1}`} />
                                                </div>
                                            );
                                        } else if (detail.type === 'video') {
                                            return (
                                                <div key={index} className="video-container">
                                                    <video 
                                                        src={detail.src} 
                                                        controls
                                                        playsInline
                                                        className="case-video"
                                                    />
                                                </div>
                                            );
                                        } else if (detail.type === 'title') {
                                            return (
                                                <div key={index} className="detail-section">
                                                    <h4>{detail.text}</h4>
                                                </div>
                                            );
                                        } else if (detail.type === 'text') {
                                            return (
                                                <div key={index} className="detail-section">
                                                    <p>{detail.text}</p>
                                                </div>
                                            );
                                        }
                                        return null;
                                    })}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default CVPage;

